// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"72":"Cart","155":"FullGoods","187":"NotFound"}[chunkId] || chunkId) + "." + {"72":"1a50d6b4","155":"a43452d6","187":"d1481b1d","787":"84352f18"}[chunkId] + ".chunk.js";
};